module.exports = __webpack_public_path__ + "img/GALLERY-ERTIGA-4.64ffaa41.jpg";